const CHATSERVER_BASE_URL = window.config.CHATSERVER_BASE_URL,
    CHATSERVER_JWT = window.config.CHATSERVER_JWT,
    INPUT_OPTIONS = require('./misseddelivery-setup'),
    _ = require('lodash');

let redeliveryCutOffs = [];

function MissedDelivery(ProxyService, $http) {
    this.proxyService = ProxyService;
    this.$http = $http;
    this.resheduleDeliveryURL = `${CHATSERVER_BASE_URL}/api/Zendesk/PostCreateTicket`;
    this.redeliveryCutOffURL = `${CHATSERVER_BASE_URL}/api/Azure/GetRedeliveryCutOff`;
}

MissedDelivery.prototype.getFieldId = function (key) {
    return INPUT_OPTIONS[key] && INPUT_OPTIONS[key].fieldId ? INPUT_OPTIONS[key].fieldId : undefined;
};

MissedDelivery.prototype.setReDeliveryCutOff = function (callback) {
    this.$http.get(this.redeliveryCutOffURL, { headers: { 'Ocp-Apim-Subscription-Key': CHATSERVER_JWT } })
    .then( function(response) {
        redeliveryCutOffs = response.data.data.holidays.map(holiday => {
            return {
                isClosed: holiday['Link Requirements'] ? holiday['Link Requirements'] === 'Day Removed' : false,
                windowsRemoved: holiday['Link Requirements'] ? holiday['Link Requirements'] === 'Windows after 4pm removed' : false,
                date: getDateFromString(holiday.date)
            };
        });
        callback();
    }, function() {
        redeliveryCutOffs = [];
    });
};

const getMonthIndex = (monthName) => {
    const months = [
        "January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
    ];

    const monthIndex = months.findIndex(
        (month) => month.toLowerCase() === monthName.toLowerCase()
    );

    if (monthIndex === -1) {
        throw new Error(`Invalid month name: "${monthName}"`);
    }

    return monthIndex;
};

const revertUserFriendlyFormat = (usrFrndlyDate) => {
    const dateChunks = usrFrndlyDate
        .split(' ')
        .reduce((str, part, i) => str + (i === 2 ? ',' : '') + part)
        .split(',');

    const day = dateChunks[1].replace(/(\d+)(st|nd|rd|th)/g, '$1');
    const month = dateChunks[2];

    const newDate = new Date();
    newDate.setMonth(getMonthIndex(month));
    newDate.setDate(day);
    return newDate;
};

const isToday = (usrFrndlyDate) => {
    const today = new Date();
    const dateObj = revertUserFriendlyFormat(usrFrndlyDate);

    return dateObj.getDate() === today.getDate() &&
        dateObj.getMonth() === today.getMonth() &&
        dateObj.getFullYear() === today.getFullYear();
};

const addDays = (date, days) => {
    const result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
};

const getDateWithOrdinalSuffix = (dt) => {
    return dt.getDate() + (dt.getDate() % 10 === 1 && dt.getDate() !== 11 ? 'st' : (dt.getDate() % 10 === 2 && dt.getDate() !== 12 ? 'nd' : (dt.getDate() % 10 === 3 && dt.getDate() !== 13 ? 'rd' : 'th')));
};

const getFormattedDate = (d) => {
    const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    const dateObj = new Date(d);
    const month = new Intl.DateTimeFormat('en', { month: 'long' }).format(dateObj);
    const date = getDateWithOrdinalSuffix(dateObj);
    const day = days[dateObj.getDay()];

    return `${day}, ${date} ${month}`;
};

const getDateFromString = (str) => {
    const dateString = str.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
    return new Date(dateString[3], dateString[2] - 1, dateString[1]);
};

MissedDelivery.prototype.getDeliveryDays = function () {
    const deliveryDays = [];
    const startDateIndex = new Date().getHours() < 18 ? 0 : 1;

    for (let i = startDateIndex; i < startDateIndex + 7; i++) {
        const newDate = addDays(new Date(), i);
        const formattedDate = getFormattedDate(newDate);
        deliveryDays.push({
            label: formattedDate,
            value: formattedDate
        });
    }
    return deliveryDays;
};

const getHolidayTime = (date) => {
    const dateObj = revertUserFriendlyFormat(date);
    const holidayTime = redeliveryCutOffs.find(cutOff => {
        const cutOffDate = cutOff.date;
        return dateObj.getDate() === cutOffDate.getDate() &&
            dateObj.getMonth() === cutOffDate.getMonth() &&
            dateObj.getFullYear() === cutOffDate.getFullYear();
    });
    return holidayTime;
};

MissedDelivery.prototype.isTimeSlotExpire  = function (deliveryDay,deliveryTime) {
    const currentHour = new Date().getHours();
    if(isToday(deliveryDay, 'dddd, Do MMMM'))
    {
      if(deliveryTime == "10 am - 12 pm"){
        return currentHour >= 10 && currentHour <= 12
      }
      else if(deliveryTime == "12 pm - 2 pm"){
        return currentHour >= 12 && currentHour <= 14
      }
      else if(deliveryTime == "2 pm - 4 pm"){
        return currentHour >= 14 && currentHour <= 16
      }
      else if(deliveryTime == "4 pm - 6 pm"){
        return currentHour >= 16 && currentHour <= 18
      }
      else if(deliveryTime == "6 pm - 8 pm"){
        return currentHour >= 18 && currentHour <= 20
      }
      else{
        return false;
      }
   }
};

MissedDelivery.prototype.getDeliveryTimes = function (deliveryDay) {
    const deliveryTimes = [];
    const currentHour = new Date().getHours();
    const holidayTime = getHolidayTime(deliveryDay);
    for (let i = 10; i <= 18; i += 2) {
        if (!isToday(deliveryDay) ||
            (isToday(deliveryDay) && currentHour < i)) {
            const startTime = `${i === 12 ? 12 : i % 12} ${i < 12 ? 'am' : 'pm'}`;
            const endTime = `${(i + 2) === 12 ? 12 : (i + 2) % 12} pm`;
            const timeString = `${startTime} - ${endTime}`;
            deliveryTimes.push({
                label: timeString,
                value: timeString
            });
        }
    }

    if (holidayTime && holidayTime.windowsRemoved) {
        deliveryTimes.splice(deliveryTimes.length - 2, 2);
    }

    if (!deliveryTimes.length) {
        deliveryTimes.push({
            label: 'Time slots are not available',
            value: 'Time slots are not available'
        });
    }

    return deliveryTimes;
};

MissedDelivery.prototype.getClosedDays = function () {
    const closedDates = redeliveryCutOffs.filter(cutOff => cutOff.isClosed);
    const closedDays = closedDates.length && closedDates.map(closedDate => getFormattedDate(closedDate.date));
    return closedDays;
};

const getTicketBodyContent = (selected) => {
    const deliveryDay = selected.deliveryDay.value;
    const deliveryTime = selected.deliveryTime.value;
    let receiveProduct = '';

    switch (selected.receiveProduct) {
        case 'pickUpFromStore':
            receiveProduct = 'Pick up from the store';
            break;
        case 'reDeliver':
            receiveProduct = 'Re deliver to the same address';
            break;
        case 'cancelOrder':
            receiveProduct = 'Cancel my order';
            break;
        default:
            receiveProduct = '';
    }
    return `How would you like to receive your product: ${receiveProduct}\n
    Preferred delivery day: ${deliveryDay !== '' ? deliveryDay : 'N/A'}\n
    Preferred delivery time: ${deliveryTime !== '' ? deliveryTime : 'N/A'}\n
    Customer comments: ${selected.comment.body}`;
};

MissedDelivery.prototype.submitForm = function (selected) {
    const subjectValue = 'Help Centre: Delivery now contact form';
    const ticketRequest = {
        appName: 'BWSUI',
        ticket: {
            subject: subjectValue,
            comment: {
                body: getTicketBodyContent(selected)
            },
            brand_id: this.getFieldId('brand_id'),
            ticket_form_id: this.getFieldId('ticket_form_id'),
            custom_fields: []
        }
    };

    ticketRequest.ticket.requester = {
        name: `${selected.firstName} ${selected.lastName}`,
        email: selected.email
    };

    ticketRequest.ticket.custom_fields.push({
        id: 360000211996,
        value: 'delivery___pick_up_from_store'
    },
        {
            id: 360000208455,
            value: 'i_want_to_change_my_delivery'
        }
    );

    //Other fields
    _.mapKeys(selected, (selectedValue, key) => {
        if (selectedValue && this.getFieldId(key)) {
            const id = this.getFieldId(key);
            let value = selectedValue.value ? selectedValue.value : selectedValue;
            if (value.label && value.label === '-') {
                value = null;
            }
            if (value) {
                ticketRequest.ticket.custom_fields.push({
                    id,
                    value
                });
            }
        }
    });

    return this.$http.post(this.resheduleDeliveryURL, ticketRequest, { headers: { 'Ocp-Apim-Subscription-Key': CHATSERVER_JWT } });
};


module.exports = MissedDelivery;



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/misseddelivery/misseddelivery-service.js
 **/